export default {
  getUserInfo(state,payload){
      state.userInfo = payload
  },
  setFooterInfo(state, info) {
    state.footerInfo = info
  },
  getSecurityConfig(state, payload){
    state.securityConfig = payload
  }
}